import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getListIndicatorPattern = (async (searchString ,orderBy) => await http({
    url: ENDPOINTS.secretariat.indicatorPatterns.browse,
    method: 'get',
    params:{
        searchString: searchString,
        orderBy: orderBy,
    }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const getIndicatorPattern = (async (Id) => await http({
    url: ENDPOINTS.secretariat.indicatorPatterns.load,
    method: 'get',
    params: {Id : Id}
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)


export const postIndicatorPattern = (data) => http({
    url: ENDPOINTS.secretariat.indicatorPatterns.browse,
    method: 'post',
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})
export const deleteIndicatorPattern = (id) => http({
    url: ENDPOINTS.secretariat.indicatorPatterns.browse,
    method: 'delete',
    params:{
        Id : id
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})


export const putIndicatorPattern = (data) => http({
    url: ENDPOINTS.secretariat.indicatorPatterns.browse,
    method: 'put',
    data:data
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

